import { BaseService } from "@services/BaseService";

class ExternalApiService extends BaseService {
  getAvailable() {
    return this.get("/external-apis/available");
  }
}

export const externalApiService = new ExternalApiService();
